<lib-logo></lib-logo>
<div class="container">

    <lib-digital-queue-list></lib-digital-queue-list>

</div>